export default "__VITE_ASSET__CBx9TzD3__"